import { type InferGetStaticPropsType, type NextPage } from "next";
import Layout from "~/components/Layout";
import ScopriBsComponent from "~/components/ScopriBSComponent";
import { getNameCategory } from "~/lib/db/category";
import {
  getHomepageLoopPosts,
  getLoopsScopriBs,
  getLoopsSpecialiSB,
  type LoopPostReturnType,
} from "~/lib/db/loops";
import { getPostsMetadata, getThumbnail } from "~/lib/db/posts";
import { getAllSpecialiForHome } from "~/lib/db/speciali";
import { postExcerpt } from "~/utils";
import Masonry from "react-masonry-css";
const breakpointColumnsObj = {
  default: 2,
  768: 1,
};

const ScopriBs: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  parole,
  speciale,
  intervista,
  omaggio,
  propostaPace,
  gommaECarboncino,
}) => {
  const concatCategorie = [
    parole,
    speciale,
    intervista,
    omaggio,
    propostaPace,
    gommaECarboncino,
  ];
  const items = concatCategorie.map((el, index) => {
    return {
      id: index,
      post: el,
    };
  });

  return (
    <>
      <Layout>
        <main className="w-full pb-32 text-black">
          <h1 className="mx-auto mb-8 mt-12 max-w-box px-4 text-center text-5xl font-thin sm:mb-12 sm:mt-16 sm:text-6xl lg:mb-10 lg:mt-20 lg:text-[140px]">
            Scopri BS
          </h1>
          <div className="mx-auto mb-16 mt-0 max-w-box px-4 sm:mb-16 lg:mb-36 lg:w-1/2">
            <p className="text-center text-lg text-gray md:text-2xl">
              Un esempio di contenuti di “Buddismo e società” disponibili per
              chi non ha ancora l’abbonamento
            </p>
          </div>

          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid grid gap-10 lg:gap-20"
            columnClassName="my-masonry-grid_column grid gap-y-10 lg:gap-y-20"
          >
            {items.map((item, index) => (
              <ScopriBsComponent key={index} data={item} index={index} />
            ))}
          </Masonry>
        </main>
      </Layout>
    </>
  );
};

export default ScopriBs;
export const getStaticProps = async () => {
  const loopsInfo = await getLoopsScopriBs([10, 30, 40, 50]);
  const loopsInfoSpeciali = await getLoopsSpecialiSB([20]);
  const [parole, intervista, omaggio, propostaPace] = await Promise.all(
    loopsInfo.map((loop) => getHomepageLoopPosts(loop))
  );
  const gommaECarboncino = await getNameCategory(
    "le-avventure-di-gomma-e-carboncino"
  );
  const postsIds = [...parole, ...intervista, ...omaggio, ...propostaPace].map(
    ({ ID }) => ID
  );
  const [speciali] = await getAllSpecialiForHome([
    loopsInfoSpeciali[0]?.terms_id.toString(),
  ]);
  const metadata = await getPostsMetadata(postsIds);
  const thumbnail = postsIds.length > 0 ? await getThumbnail(postsIds) : [];

  const mapPostsForClient = (posts: LoopPostReturnType[], length = 100) =>
    posts.map(
      (
        {
          ID,
          post_title,
          post_name,
          post_excerpt,
          post_content,
          post_date,
          post_status,
        },
        index
      ) => ({
        post_name,
        post_title,
        post_status,
        post_excerpt:
          post_excerpt != "" && post_excerpt != "   "
            ? postExcerpt(post_excerpt, index == 0 ? length : 100)
            : postExcerpt(
                post_content?.replace(/<\/?[^>]+(>|$)/g, ""),
                index == 0 ? length : 100
              ),
        meta: metadata[Number(ID)],
        thumbnail:
          thumbnail[Number(ID)]?.thumbnail != null
            ? thumbnail[Number(ID)]?.thumbnail
            : null,
        alt:
          thumbnail[Number(ID)]?.alt != null
            ? thumbnail[Number(ID)]?.alt
            : null,
        post_date: post_date.toISOString(),
      })
    );
  return {
    props: {
      parole: mapPostsForClient(parole)[0],
      speciale: speciali,
      intervista: mapPostsForClient(intervista)[0],
      omaggio: mapPostsForClient(omaggio)[0],
      propostaPace: mapPostsForClient(propostaPace)[0],
      gommaECarboncino: {
        slug: "le-avventure-di-gomma-e-carboncino",
        name: gommaECarboncino.name,
      },
    },
  };
};
